import get from 'lodash/get';
import { TState } from '~/src/store';

export function selectDomain(state: TState): string {
   return get(state, 'auth.billingDomain') || get(state, 'city.currentCity.domain');
}

export function selectHostname(state: TState): string {
   const domain = get(state, 'auth.billingDomain');

   if (domain && domain !== 'interzet') {
      return 'https://' + domain + '.db.ertelecom.ru';
   } else {
      return get(state, 'city.currentCity.billingHost');
   }
}
